import { Inject, Injectable, OnDestroy } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject, distinctUntilChanged, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkStatusService implements OnDestroy {
  private readonly browserWindow: Window | null;
  private readonly statusSubject: BehaviorSubject<boolean>;
  readonly online$: Observable<boolean>;

  private readonly onOnline = (): void => this.statusSubject.next(true);
  private readonly onOffline = (): void => this.statusSubject.next(false);

  constructor(@Inject(DOCUMENT) document: Document) {
    this.browserWindow = document.defaultView;
    this.statusSubject = new BehaviorSubject(this.browserWindow?.navigator.onLine ?? true);
    this.online$ = this.statusSubject.asObservable().pipe(distinctUntilChanged());
    this.browserWindow?.addEventListener('online', this.onOnline);
    this.browserWindow?.addEventListener('offline', this.onOffline);
  }

  get isOnline(): boolean {
    return this.statusSubject.value;
  }

  ngOnDestroy(): void {
    this.browserWindow?.removeEventListener('online', this.onOnline);
    this.browserWindow?.removeEventListener('offline', this.onOffline);
  }
}
